export default __webpack_public_path__ + "static/media/package-bg.dddc463d.jpg";